export default __webpack_public_path__ + "static/media/home-slide2.3b75ad85.png";